// extracted by mini-css-extract-plugin
export default {"wrapper":"Payments_wrapper__dXcb2","filter":"Payments_filter__c288O"};